import { useLocale } from 'next-intl';

export default function useCurrentLocale() {
  const locale = useLocale();
  if (locale === 'en') {
    return {
      locale: '',
      localeLink: '',
    };
  } else {
    return {
      locale: locale,
      localeLink: `/${locale}`,
    };
  }
}
